import { OktaAuth } from '@okta/okta-auth-js';
import envConfig from '../config/config';

export const oktaConfig = envConfig.okta;

export const issuer = `${oktaConfig.baseUrl}/oauth2/${oktaConfig.issuer}`;
export const clientId = envConfig.authorizedClientIds.accountUi;
export const redirectUri = `${window.location.origin}/callback`;

const oktaAuthConfiguration = {
  issuer,
  clientId,
  redirectUri,
};

export const oktaAuthJSClient = new OktaAuth(oktaAuthConfiguration);

export const REDIRECT_STORAGE_KEY = 'oidc-redirect';

export const USER_SESSION_INFO = 'user-session-info';
// Initial page with just email field
export const IDP_DISCOVERY = 'idp-discovery';
// Login + Password Page
export const PRIMARY_AUTH = 'primary-auth';
